import {
    Snapshot,
    snapshotSchema,
    mockSnapshot,
} from 'app/agriculture/queries/snapshots/types/Snapshot';

export type HeartbeatSnapshot = Snapshot;
export const heartbeatSnapshotSchema = snapshotSchema;
export const mockHeartbeatSnapshot = mockSnapshot;
